import { FC, useEffect, useState } from "react"
import { ConversationStarter, getStaffStarters } from "../../../api/staff-agent"

/**
 * Context-aware starter chips on the assistant's empty state — one tap
 * starts a grounded question about the page behind the drawer ("this
 * subscription", "this embed"). Server-owned catalog (GET /api/starters);
 * renders nothing for routes without a starter set, and failures stay
 * silent (starters are a convenience, never an error surface).
 */
const StarterChips: FC<{
  page?: string
  onPick: (message: string) => void
}> = ({ page, onPick }) => {
  const [starters, setStarters] = useState<ConversationStarter[]>([])

  useEffect(() => {
    let cancelled = false
    setStarters([])
    getStaffStarters(page)
      .then(items => {
        if (!cancelled) setStarters(items)
      })
      .catch(() => {
        // Silent by design.
      })
    return () => {
      cancelled = true
    }
  }, [page])

  if (starters.length === 0) return null

  return (
    <div className="flex max-w-md flex-wrap justify-center gap-2">
      {starters.map(starter => (
        <button
          key={starter.label}
          type="button"
          onClick={() => onPick(starter.message)}
          className="rounded-full border border-violet-200 bg-violet-50/60 px-3 py-1.5 text-xs text-violet-900 transition-colors hover:bg-violet-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-400"
        >
          {starter.label}
        </button>
      ))}
    </div>
  )
}

export default StarterChips
